import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledList = styled.div `
    flex-wrap: wrap;
`;
const DefinitionList = ({ children }) => {
    return _jsx(StyledList, { children: children });
};
export default DefinitionList;
